import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { UiProvider } from './i18n/ui-context';
import { SessionProvider } from './session/session-context';
import './styles.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Missing #root element; index.html and main.tsx disagree.');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <UiProvider>
        <SessionProvider>
          <App />
        </SessionProvider>
      </UiProvider>
    </BrowserRouter>
  </StrictMode>,
);
